import styled, { css } from 'styled-components';

export const PathwayContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 1.5em;
    background-color: #1a1a1a;
    border-radius: 5px; 
    margin: 4em 2em; 
    max-width: 480px;  

    .icon-wrapper {
        display: inherit;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 120px;
        background-color: #555;
        border-radius: 50%;
        padding: 20px;
       
        img {
            width: 80px;
        }
    }
`  

export const PathwaysWrapper = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    // flex-wrap: wrap;

`
export const PathwayIcon = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2em;
    flex-basis: 33%;

    &:first-child {
        flex-basis: 100%;
    }
    &:nth-child(2n), :nth-child(3n)  {
        flex-basis: 50%; 
    }
    &:nth-child(4n), :nth-child(5n), :nth-child(6n)  {
        flex-basis: 33%; 
    }

    div.icon-wrapper {
        background-color: #2a2a2a;
        img {
            width: 50px;
        }
    }

    p.lesson-name{
        font: normal bold 14px 'Roboto';
        text-align: center;
        margin-top: .75em;
    }
`
export const CategoryIcon = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;  
    margin-top: -5em;
    margin-left: -5em;
    align-self: flex-start; 

    div.icon-wrapper {
        background-color: #555;
    }

    p.pathway-category {
        font: bold italic 20px 'Roboto';
        text-transform: uppercase;
        margin-top: .5em;
        margin-left: 1em;
    }
`


// WEBPACK FOOTER //
// ./src/components/OnBoard/Plexing/PlexPathways/PlexPathways.styles.ts